<template>
    <div class="user-stock-list container">
        <div class="row">
            <div class="col-md-12">
                <div>
                    Stock list for
                    <strong v-if="user.name && user.company">
                        {{user.company.name}}
                        ({{user.name}})
                    </strong>
                </div>
                <div>
                <div>
                    <div class="row mt-2">
                        <div class="col-6 col-md-2">
                            <strong>Sold Date</strong>
                        </div>
                        <div class="col-6 col-md-2">
                            <strong># Stock</strong>
                        </div>
                    </div>
                    <div class="row mt-2" v-for="item in stock">
                        <div class="col-6 col-md-2">
                            <a :href="$laravelRoute('vehicle-stock.myGarage') + `?user_id=${user.id}&sold_date=${item.sold_date}`">
                                {{item.sold_date}}
                            </a>
                        </div>
                        <div class="col-6 col-md-2">
                            {{item.count}}
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import {splitObjKey, objLookup, getExceptionErrorMessage, getHttpValidationErrors} from '../../util/common'

    import BootstrapValidation from '../../mixins/bootstrap-validation';
    export default {
        data() {
            return {
                stock: [],
                user: {}
            }
        },
        async mounted() {
            let data = await this.getStockList(this.$route.params.id)
            if (data) {
                this.stock = data.list
                this.user = data.user
            }
        },
        computed: {
        },
        methods: {
            ...mapActions({
                getStockList: 'users/getUserStock',
            }),
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/User/StockListDate.vue